import { VoucherProperties } from "@interfaces/voucher-properties.interface";
import { INICIO } from './url.constant';

export const SOLICITUD_CONGELAMIENTO_SALDO_RESPONSE = 'congelamiento_saldo_response';

export const VOUCHER_PAGE_PROPERTIES: VoucherProperties = {
    srcImage: '../../../../../assets/icons/success-blue.svg',
    titleSuccess: 'Recibimos tu solicitud de Congelamiento de saldo',
    subtitleSucces: '¿Que viene ahora?',
    infoSucces: 'Nos contactaremos contigo para confirmar tu solicitud, luego de esto traspasaremos tus saldos a la Cuenta Corriente del Fondo de Pensión en un plazo de 4 días hábiles.',
    subtitleSuccesEmail: 'Este es tu comprobante',
    infoSuccesClientWithEmail:'También lo enviamos a tu correo ?. Si no lo encuentras en tu bandeja principal, por favor, revisa el spam',
    infoSuccesClientWithoutEmail:'Aún no registras un correo para recibir tus comprobantes, por favor agrega uno en ',
    buttonText: 'Ir a Inicio',
    goBackText: 'Volver a Congelamiento de saldo'
};

export const CONFIRM_SOLICITUD_ERROR = {
    titleRetry:'Ocurrió un error al ingresar tu solicitud de congelamiento de saldo',
    subtitleRetry: 'Ante dudas llámanos al <b>600 6600 900</b>, escríbenos a WhatsApp <b>+569 3639 1222</b> o dirígete a nuestras sucursales.',
    infoRetry: 'Por favor, reinténtalo o ingresa más tarde',
    srcImage: '/assets/contactotdp/icons/info_fill.svg',
    buttonTextPrimary: 'Reintentar',
    buttonTextSecondary: 'Ir a Inicio',
    buttonUrlSecondary: INICIO,
};